import { useState, useEffect, useRef } from "react";


/* ─── ASSETS ────────────────────────────────────────── */
const ICON_SRC = "/images/icon.jpg";
const LOGO_SRC = "/images/logo.png";

/* ─── COUNTRY CODES ────────────────────────────────────────────── */
const COUNTRIES = [
  { code: "+91", name: "India", flag: "🇮🇳", iso: "IN" },
  { code: "+1", name: "USA", flag: "🇺🇸", iso: "US" },
  { code: "+44", name: "UK", flag: "🇬🇧", iso: "GB" },
  { code: "+61", name: "Australia", flag: "🇦🇺", iso: "AU" },
  { code: "+971", name: "UAE", flag: "🇦🇪", iso: "AE" },
  { code: "+966", name: "Saudi Arabia", flag: "🇸🇦", iso: "SA" },
  { code: "+65", name: "Singapore", flag: "🇸🇬", iso: "SG" },
  { code: "+60", name: "Malaysia", flag: "🇲🇾", iso: "MY" },
  { code: "+49", name: "Germany", flag: "🇩🇪", iso: "DE" },
  { code: "+33", name: "France", flag: "🇫🇷", iso: "FR" },
  { code: "+81", name: "Japan", flag: "🇯🇵", iso: "JP" },
  { code: "+82", name: "South Korea", flag: "🇰🇷", iso: "KR" },
  { code: "+55", name: "Brazil", flag: "🇧🇷", iso: "BR" },
  { code: "+86", name: "China", flag: "🇨🇳", iso: "CN" },
  { code: "+7", name: "Russia", flag: "🇷🇺", iso: "RU" },
  { code: "+27", name: "South Africa", flag: "🇿🇦", iso: "ZA" },
  { code: "+234", name: "Nigeria", flag: "🇳🇬", iso: "NG" },
  { code: "+92", name: "Pakistan", flag: "🇵🇰", iso: "PK" },
  { code: "+880", name: "Bangladesh", flag: "🇧🇩", iso: "BD" },
  { code: "+94", name: "Sri Lanka", flag: "🇱🇰", iso: "LK" },
  { code: "+977", name: "Nepal", flag: "🇳🇵", iso: "NP" },
  { code: "+64", name: "New Zealand", flag: "🇳🇿", iso: "NZ" },
  { code: "+31", name: "Netherlands", flag: "🇳🇱", iso: "NL" },
  { code: "+46", name: "Sweden", flag: "🇸🇪", iso: "SE" },
  { code: "+47", name: "Norway", flag: "🇳🇴", iso: "NO" },
  { code: "+45", name: "Denmark", flag: "🇩🇰", iso: "DK" },
  { code: "+41", name: "Switzerland", flag: "🇨🇭", iso: "CH" },
  { code: "+90", name: "Turkey", flag: "🇹🇷", iso: "TR" },
  { code: "+62", name: "Indonesia", flag: "🇮🇩", iso: "ID" },
  { code: "+63", name: "Philippines", flag: "🇵🇭", iso: "PH" },
  { code: "+66", name: "Thailand", flag: "🇹🇭", iso: "TH" },
  { code: "+84", name: "Vietnam", flag: "🇻🇳", iso: "VN" },
  { code: "+20", name: "Egypt", flag: "🇪🇬", iso: "EG" },
  { code: "+34", name: "Spain", flag: "🇪🇸", iso: "ES" },
  { code: "+39", name: "Italy", flag: "🇮🇹", iso: "IT" },
  { code: "+48", name: "Poland", flag: "🇵🇱", iso: "PL" },
  { code: "+43", name: "Austria", flag: "🇦🇹", iso: "AT" },
  { code: "+32", name: "Belgium", flag: "🇧🇪", iso: "BE" },
  { code: "+351", name: "Portugal", flag: "🇵🇹", iso: "PT" },
];

/* ─── CATEGORIES ────────────────────────────────────────────────── */
const CATS = [
  { id: "car",       label: "Car",       emoji: "🚗", color: "#FF6B6B", bg: "#FFF0F0" },
  { id: "laptop",    label: "Laptop",    emoji: "💻", color: "#4A90D9", bg: "#EEF5FF" },
  { id: "bike",      label: "Bike",      emoji: "🏍️", color: "#F5A623", bg: "#FFF8EC" },
  { id: "house",     label: "House",     emoji: "🏠", color: "#27AE60", bg: "#EDFBF2" },
  { id: "mobile",    label: "Mobile",    emoji: "📱", color: "#9B59B6", bg: "#F7EFFF" },
  { id: "travel",    label: "Travel",    emoji: "✈️", color: "#1ABC9C", bg: "#EAFAF6" },
  { id: "education", label: "Education", emoji: "🎓", color: "#E67E22", bg: "#FFF4E8" },
  { id: "tv",        label: "TV",        emoji: "📺", color: "#E74C3C", bg: "#FFF0EE" },
  { id: "gold",      label: "Gold",      emoji: "💍", color: "#D4AC0D", bg: "#FFFBE6" },
  { id: "other",     label: "Other",     emoji: "🎯", color: "#7F8C8D", bg: "#F4F6F7" },
];

/* ─── UTILS ─────────────────────────────────────────────────────── */
const getCat = (id) => CATS.find(c => c.id === id) || CATS[9];
const formatINR = (n) => "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
const calcDays = (d) => Math.floor((new Date(d) - new Date()) / 86400000);
const formatTimeLeft = (days) => {
  if (days < 0) return "Overdue";
  if (days === 0) return "Today";
  if (days < 30) return `${days}d left`;
  if (days < 365) return `${Math.floor(days / 30)}mo left`;
  return `${Math.floor(days / 365)}yr left`;
};
const formatDate = (d) => new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, ".");
const LS = {
  get: (k) => {
    try { const v=localStorage.getItem(k); return v ? JSON.parse(v) : null; }
    catch(e) { console.error("[LS.get]",k,e); return null; }
  },
  set: (k, v) => {
    try { localStorage.setItem(k, JSON.stringify(v)); return true; }
    catch(e) { console.error("[LS.set]",k,e); return false; }
  },
  del: (k) => { try { localStorage.removeItem(k); } catch(e){} },
};
// Consistent phone key: strip all except digits and leading +
const mkPhone = (code, num) => (code.trim() + num.replace(/\D/g,'')).replace(/\s+/g,'');

const DEMO_GOALS = [
  { id: 1, category: "car",    title: "Dream Car",   description: "To buy a car",       target: 1200000, saved: 0,     deadline: "2027-03-13", createdAt: new Date().toISOString(), history: [] },
  { id: 2, category: "bike",   title: "Bike",         description: "To buy a Bike",      target: 135000,  saved: 89000, deadline: "2026-04-01", createdAt: new Date(Date.now() - 2*86400000).toISOString(), history: [{ id: 1, amount: 89000, note: "Initial savings", date: new Date(Date.now()-30*86400000).toISOString() }] },
  { id: 3, category: "mobile", title: "iPhone 16 Pro",description: "Buy latest iPhone",  target: 130000,  saved: 45000, deadline: "2026-08-15", createdAt: new Date().toISOString(), history: [{ id: 1, amount: 45000, note: "First deposit", date: new Date().toISOString() }] },
];

/* ─── SHARED INPUT STYLES ───────────────────────────────────────── */
const inputStyle = { width:"100%",padding:"13px 16px",border:"1.5px solid #E2E8F0",borderRadius:14,fontSize:15,fontFamily:"'DM Sans',sans-serif",color:"#1A202C",background:"#FAFBFD",outline:"none",boxSizing:"border-box",transition:"border-color .2s,box-shadow .2s" };
const labelStyle = { fontSize:12,fontWeight:700,color:"#94A3B8",marginBottom:6,display:"block",letterSpacing:.6,fontFamily:"'DM Sans',sans-serif",textTransform:"uppercase" };
const primaryBtn = (color="#3B82F6",full=true)=>({ width:full?"100%":"auto",padding:"14px 28px",borderRadius:14,border:"none",background:`linear-gradient(135deg,${color},${color}CC)`,color:"#fff",fontWeight:700,fontSize:15,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",boxShadow:`0 4px 18px ${color}45`,transition:"transform .15s,box-shadow .15s",letterSpacing:.3 });

/* ════════════════════════════════════════════════════════════════
   LANDING PAGE
═══════════════════════════════════════════════════════════════ */
const LandingPage = ({ onSignup, onLogin }) => {
  const [mobileMenu, setMobileMenu] = useState(false);
  
  const features = [
    { icon:"🎯", title:"Set Smart Goals",   desc:"Create savings goals for car, house, laptop, bike, mobile & more. Set deadlines and track progress in real-time." },
    { icon:"📊", title:"Visual Progress",   desc:"Beautiful circular charts, progress bars & monthly targets help you stay on track toward every goal." },
    { icon:"🔔", title:"Deadline Alerts",   desc:"Get notified when deadlines are approaching. Never miss a savings milestone with smart reminders." },
    { icon:"💰", title:"Log Transactions",  desc:"Log every savings deposit with notes. Full transaction history keeps your saving journey organized." },
    { icon:"🔒", title:"Secure & Private",  desc:"Your data is protected. OTP-based login, password security and encrypted user accounts." },
    { icon:"⇅",  title:"Custom Priority",   desc:"Reorder your goals by drag & drop — prioritize what matters most to you." },
  ];
  const stats = [
    { value:"10K+", label:"Users" },
    { value:"₹50Cr+", label:"Saved" },
    { value:"4.9★", label:"Rating" },
    { value:"Free", label:"Forever" },
  ];
  const testimonials = [
    { name:"Ravi Kumar",    loc:"Hyderabad",  text:"Saved ₹1.2L for my bike in 8 months! The progress tracker keeps me motivated every day.",  avatar:"👨‍💼" },
    { name:"Priya Sharma",  loc:"Bangalore",  text:"Finally bought my MacBook Air thanks to Savings Tracker. The deadline reminders are genius!", avatar:"👩‍💻" },
    { name:"Arjun Reddy",   loc:"Chennai",    text:"Managing 5 goals at once — car, house, travel, phone, education. Best finance app ever!",   avatar:"👨‍🎓" },
  ];

  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif", background:"#fff", minHeight:"100vh", overflowX:"hidden" }}>

      {/* ── NAVBAR ── */}
      <nav style={{ position:"sticky",top:0,zIndex:100,background:"rgba(255,255,255,0.95)",backdropFilter:"blur(20px)",borderBottom:"1px solid #F0F7F4",padding:"0 24px",display:"flex",alignItems:"center",justifyContent:"space-between",height:68,maxWidth:"100%",boxShadow:"0 2px 20px rgba(0,0,0,0.06)" }}>
        {/* Logo */}
        <div style={{ display:"flex",alignItems:"center",cursor:"pointer" }}>
          <img src={LOGO_SRC} alt="Savings Tracker" style={{ height:42,objectFit:"contain",maxWidth:180 }} />
        </div>

        {/* Desktop Nav Links */}
        <div style={{ display:"flex",alignItems:"center",gap:28 }} className="desktop-nav">
          {["Features","How It Works","Testimonials","Download"].map(l=>(
            <a key={l} href={`#${l.toLowerCase().replace(/ /g,"-")}`} style={{ color:"#475569",fontSize:14,fontWeight:600,textDecoration:"none",transition:"color .2s" }}
               onMouseEnter={e=>{e.target.style.color="#3B82F6";}} onMouseLeave={e=>{e.target.style.color="#475569";}}>{l}</a>
          ))}
        </div>

        {/* Auth Buttons */}
        <div style={{ display:"flex",alignItems:"center",gap:10 }}>
          <button onClick={onLogin} style={{ padding:"10px 20px",borderRadius:12,border:"2px solid #E2E8F0",background:"#fff",cursor:"pointer",fontWeight:700,fontSize:14,color:"#0F172A",fontFamily:"'DM Sans',sans-serif",transition:"all .2s" }}
            onMouseEnter={e=>{e.target.style.borderColor="#3B82F6";e.target.style.color="#3B82F6";}}
            onMouseLeave={e=>{e.target.style.borderColor="#E2E8F0";e.target.style.color="#0F172A";}}>Login</button>
          <button onClick={onSignup} style={{ padding:"10px 20px",borderRadius:12,border:"none",background:"linear-gradient(135deg,#3B82F6,#2563EB)",cursor:"pointer",fontWeight:700,fontSize:14,color:"#fff",fontFamily:"'DM Sans',sans-serif",boxShadow:"0 4px 14px #3B82F645",transition:"all .2s" }}
            onMouseEnter={e=>{e.target.style.transform="translateY(-1px)";}}
            onMouseLeave={e=>{e.target.style.transform="";}}>Sign Up Free</button>
        </div>
      </nav>

      {/* Mobile Menu Dropdown */}
      {mobileMenu && (
        <div style={{ position:"fixed",top:68,left:0,right:0,background:"#fff",zIndex:99,borderBottom:"2px solid #F0F4F8",boxShadow:"0 8px 24px rgba(0,0,0,0.12)",padding:"16px 24px 24px",animation:"slideDown .2s ease" }}>
          {["Features","How It Works","Testimonials","Download"].map(l=>(
            <a key={l} href={`#${l.toLowerCase().replace(/ /g,"-")}`} onClick={()=>setMobileMenu(false)} style={{ display:"block",padding:"14px 0",fontSize:17,fontWeight:600,color:"#1A202C",borderBottom:"1px solid #F8FAFC",textDecoration:"none" }}>{l}</a>
          ))}
          <div style={{ display:"flex",gap:10,marginTop:16 }}>
            <button onClick={()=>{setMobileMenu(false);onLogin();}} style={{ flex:1,padding:"13px",borderRadius:12,border:"2px solid #E2E8F0",background:"#fff",cursor:"pointer",fontWeight:700,fontSize:15,color:"#0F172A",fontFamily:"'DM Sans',sans-serif" }}>Login</button>
            <button onClick={()=>{setMobileMenu(false);onSignup();}} style={{ flex:1,padding:"13px",borderRadius:12,border:"none",background:"linear-gradient(135deg,#3B82F6,#2563EB)",cursor:"pointer",fontWeight:700,fontSize:15,color:"#fff",fontFamily:"'DM Sans',sans-serif" }}>Sign Up Free</button>
          </div>
        </div>
      )}

      {/* ── HERO ── */}
      <section style={{ background:"linear-gradient(160deg,#0F172A 0%,#0F172A 40%,#1E3A8A 70%,#1D4ED8 100%)",padding:"80px 24px 100px",position:"relative",overflow:"hidden" }}>
        {/* BG Orbs */}
        {[{t:-100,l:-100,s:400,c:"#3B82F620"},{t:200,r:-120,s:300,c:"#60A5FA15"},{b:-80,l:"40%",s:250,c:"#93C5FD20"}].map((o,i)=>(
          <div key={i} style={{ position:"absolute",width:o.s,height:o.s,borderRadius:"50%",background:o.c,top:o.t,left:o.l,right:o.r,bottom:o.b,filter:"blur(60px)",pointerEvents:"none" }} />
        ))}

        <div style={{ maxWidth:900,margin:"0 auto",display:"flex",flexDirection:"column",alignItems:"center",textAlign:"center",position:"relative",zIndex:2 }}>
          <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"rgba(16,185,129,0.15)",border:"1px solid rgba(16,185,129,0.3)",borderRadius:99,padding:"8px 18px",marginBottom:32 }}>
            <span style={{ fontSize:14 }}>✨</span>
            <span style={{ fontSize:13,fontWeight:700,color:"#93C5FD",letterSpacing:.5 }}>#1 Savings Goal Tracker in India</span>
          </div>

          <h1 style={{ fontSize:"clamp(36px,7vw,72px)",fontWeight:900,color:"#fff",margin:"0 0 20px",lineHeight:1.1,letterSpacing:-1 }}>
            Save Smarter.<br />
            <span style={{ background:"linear-gradient(90deg,#3B82F6,#60A5FA,#93C5FD)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent" }}>Achieve Faster.</span>
          </h1>
          <p style={{ fontSize:"clamp(16px,2.5vw,20px)",color:"#94A3B8",margin:"0 0 44px",maxWidth:560,lineHeight:1.7 }}>
            Track your savings goals for 🚗 Car, 🏠 House, 💻 Laptop, 📱 Mobile & more — all in one beautiful app, completely free.
          </p>

          <div style={{ display:"flex",flexWrap:"wrap",gap:12,justifyContent:"center",marginBottom:60 }}>
            <button onClick={onSignup} style={{ ...primaryBtn(),padding:"16px 36px",fontSize:17,borderRadius:16,boxShadow:"0 8px 32px #3B82F655" }}>
              Get Started Free →
            </button>
            <button onClick={onLogin} style={{ padding:"16px 36px",borderRadius:16,border:"2px solid rgba(255,255,255,0.2)",background:"rgba(255,255,255,0.08)",color:"#fff",fontWeight:700,fontSize:17,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",transition:"all .2s",backdropFilter:"blur(10px)" }}
              onMouseEnter={e=>{e.target.style.background="rgba(255,255,255,0.14)";}}
              onMouseLeave={e=>{e.target.style.background="rgba(255,255,255,0.08)";}}>
              Login
            </button>
          </div>

          {/* Stats Row */}
          <div style={{ display:"flex",flexWrap:"wrap",gap:0,background:"rgba(255,255,255,0.06)",borderRadius:20,border:"1px solid rgba(255,255,255,0.1)",backdropFilter:"blur(10px)",overflow:"hidden" }}>
            {stats.map((s,i)=>(
              <div key={s.label} style={{ padding:"20px 32px",textAlign:"center",borderRight:i<stats.length-1?"1px solid rgba(255,255,255,0.08)":"none" }}>
                <div style={{ fontSize:26,fontWeight:900,color:"#3B82F6" }}>{s.value}</div>
                <div style={{ fontSize:12,color:"#64748B",fontWeight:600,letterSpacing:.5,marginTop:2 }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PHONE MOCKUP SECTION ── */}
      <section style={{ background:"#F8FAFC",padding:"80px 24px" }}>
        <div style={{ maxWidth:1100,margin:"0 auto",display:"flex",flexWrap:"wrap",alignItems:"center",gap:60,justifyContent:"center" }}>
          {/* Phone Mockup */}
          <div style={{ position:"relative",flexShrink:0 }}>
            {/* Glow */}
            <div style={{ position:"absolute",inset:"-40px",background:"radial-gradient(circle,#3B82F620 0%,transparent 70%)",borderRadius:"50%",zIndex:0 }} />
            {/* Phone outer */}
            <div style={{ position:"relative",zIndex:1,width:240,background:"#0F172A",borderRadius:44,padding:"12px 10px",boxShadow:"0 40px 80px rgba(0,0,0,0.4),0 0 0 1px rgba(255,255,255,0.08)",border:"2px solid #1E293B" }}>
              {/* Notch */}
              <div style={{ width:80,height:24,background:"#0F172A",borderRadius:99,margin:"0 auto 8px",border:"2px solid #1E293B",position:"relative" }}>
                <div style={{ width:10,height:10,background:"#1E293B",borderRadius:"50%",position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)" }} />
              </div>
              {/* Screen */}
              <div style={{ background:"linear-gradient(160deg,#0F172A,#1E3A8A)",borderRadius:32,overflow:"hidden",minHeight:420,padding:14,position:"relative" }}>
                {/* App Header */}
                <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16 }}>
                  <div>
                    <div style={{ fontSize:16,fontWeight:900,color:"#fff" }}>Dashboard</div>
                    <div style={{ fontSize:9,color:"#93C5FD" }}>Hi, Ravi 👋</div>
                  </div>
                  <div style={{ width:28,height:28,borderRadius:"50%",background:"#3B82F6",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:900,color:"#fff" }}>R</div>
                </div>
                {/* Summary card */}
                <div style={{ background:"rgba(255,255,255,0.1)",borderRadius:16,padding:12,marginBottom:12,backdropFilter:"blur(10px)" }}>
                  <div style={{ fontSize:9,color:"#93C5FD",fontWeight:700,letterSpacing:1 }}>TOTAL SAVINGS</div>
                  <div style={{ fontSize:20,fontWeight:900,color:"#fff",margin:"4px 0 2px" }}>₹1,34,000</div>
                  <div style={{ background:"rgba(255,255,255,0.15)",borderRadius:99,height:5,overflow:"hidden",marginTop:8 }}>
                    <div style={{ height:"100%",width:"42%",background:"linear-gradient(90deg,#3B82F6,#60A5FA)",borderRadius:99 }} />
                  </div>
                </div>
                {/* Goal cards */}
                {[{e:"🚗",t:"Dream Car",p:"0%",c:"#EF4444"},{e:"🏍️",t:"Bike",p:"66%",c:"#3B82F6"},{e:"📱",t:"iPhone 16",p:"35%",c:"#8B5CF6"}].map(g=>(
                  <div key={g.t} style={{ background:"rgba(255,255,255,0.08)",borderRadius:12,padding:"8px 10px",marginBottom:6,display:"flex",alignItems:"center",gap:8 }}>
                    <div style={{ fontSize:18 }}>{g.e}</div>
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:10,fontWeight:700,color:"#fff" }}>{g.t}</div>
                      <div style={{ background:"rgba(255,255,255,0.1)",borderRadius:99,height:4,marginTop:4,overflow:"hidden" }}>
                        <div style={{ height:"100%",width:g.p,background:g.c,borderRadius:99 }} />
                      </div>
                    </div>
                    <div style={{ fontSize:10,fontWeight:800,color:g.c }}>{g.p}</div>
                  </div>
                ))}
              </div>
              {/* Home bar */}
              <div style={{ width:80,height:4,background:"#334155",borderRadius:99,margin:"10px auto 0" }} />
            </div>
          </div>

          {/* Text */}
          <div style={{ maxWidth:480 }}>
            <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:99,padding:"6px 16px",marginBottom:24 }}>
              <span style={{ fontSize:12,fontWeight:700,color:"#2563EB",letterSpacing:.5 }}>📱 AVAILABLE ON ALL DEVICES</span>
            </div>
            <h2 style={{ fontSize:"clamp(28px,5vw,42px)",fontWeight:900,color:"#0F172A",margin:"0 0 20px",lineHeight:1.15,letterSpacing:-.5 }}>
              Your financial goals,<br/><span style={{ color:"#3B82F6" }}>beautifully tracked.</span>
            </h2>
            <p style={{ fontSize:16,color:"#64748B",lineHeight:1.8,margin:"0 0 32px" }}>
              Whether you're saving for a car, a dream vacation, a new phone, or your first home — Savings Tracker keeps you focused, motivated and on schedule.
            </p>
            {/* Download Badges */}
            <div id="download" style={{ display:"flex",flexWrap:"wrap",gap:12 }}>
              <span onClick={()=>alert("iOS App coming soon! Use the web version now.")} style={{ textDecoration:"none",cursor:"pointer" }}>
                <div style={{ display:"flex",alignItems:"center",gap:12,background:"#0F172A",borderRadius:16,padding:"12px 20px",border:"1px solid #334155",cursor:"pointer",transition:"all .2s",boxShadow:"0 4px 16px rgba(0,0,0,0.25)" }}
                  onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";}}
                  onMouseLeave={e=>{e.currentTarget.style.transform="";}}>
                  <div style={{ fontSize:30 }}>🍎</div>
                  <div>
                    <div style={{ fontSize:10,color:"#94A3B8",fontWeight:600,letterSpacing:.5 }}>Download on the</div>
                    <div style={{ fontSize:18,fontWeight:900,color:"#fff",lineHeight:1 }}>App Store</div>
                  </div>
                </div>
              </span>
              <span onClick={()=>alert("Android App coming soon! Use the web version now.")} style={{ textDecoration:"none",cursor:"pointer" }}>
                <div style={{ display:"flex",alignItems:"center",gap:12,background:"#0F172A",borderRadius:16,padding:"12px 20px",border:"1px solid #334155",cursor:"pointer",transition:"all .2s",boxShadow:"0 4px 16px rgba(0,0,0,0.25)" }}
                  onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";}}
                  onMouseLeave={e=>{e.currentTarget.style.transform="";}}>
                  <div style={{ fontSize:30 }}>▶️</div>
                  <div>
                    <div style={{ fontSize:10,color:"#94A3B8",fontWeight:600,letterSpacing:.5 }}>GET IT ON</div>
                    <div style={{ fontSize:18,fontWeight:900,color:"#fff",lineHeight:1 }}>Google Play</div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section id="features" style={{ padding:"80px 24px",background:"#fff" }}>
        <div style={{ maxWidth:960,margin:"0 auto",textAlign:"center" }}>
          <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"#EFF6FF",border:"1px solid #BFDBFE",borderRadius:99,padding:"6px 16px",marginBottom:24 }}>
            <span style={{ fontSize:12,fontWeight:700,color:"#2563EB",letterSpacing:.5 }}>⚡ POWERFUL FEATURES</span>
          </div>
          <h2 style={{ fontSize:"clamp(28px,5vw,44px)",fontWeight:900,color:"#0F172A",margin:"0 0 16px",letterSpacing:-.5 }}>Everything you need to<br/><span style={{ color:"#3B82F6" }}>save more, worry less.</span></h2>
          <p style={{ fontSize:17,color:"#64748B",margin:"0 0 60px",lineHeight:1.7 }}>Built for Indians, packed with smart tools to help you reach your financial goals faster.</p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:24 }}>
            {features.map((f,i)=>(
              <div key={i} style={{ background:"#F8FAFC",borderRadius:24,padding:"28px 24px",textAlign:"left",border:"1.5px solid #F0F4F8",transition:"all .25s",cursor:"default" }}
                onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.borderColor="#3B82F650";e.currentTarget.style.boxShadow="0 12px 36px rgba(16,185,129,0.12)";}}
                onMouseLeave={e=>{e.currentTarget.style.transform="";e.currentTarget.style.borderColor="#F0F4F8";e.currentTarget.style.boxShadow="";}}>
                <div style={{ width:52,height:52,borderRadius:16,background:"linear-gradient(135deg,#EFF6FF,#DBEAFE)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,marginBottom:16 }}>{f.icon}</div>
                <h3 style={{ fontSize:18,fontWeight:800,color:"#0F172A",margin:"0 0 8px" }}>{f.title}</h3>
                <p style={{ fontSize:14,color:"#64748B",lineHeight:1.7,margin:0 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section id="how-it-works" style={{ padding:"80px 24px",background:"linear-gradient(160deg,#EFF6FF,#EFF6FF)" }}>
        <div style={{ maxWidth:800,margin:"0 auto",textAlign:"center" }}>
          <h2 style={{ fontSize:"clamp(28px,5vw,44px)",fontWeight:900,color:"#0F172A",margin:"0 0 60px",letterSpacing:-.5 }}>
            Start saving in <span style={{ color:"#3B82F6" }}>3 simple steps</span>
          </h2>
          <div style={{ display:"flex",flexWrap:"wrap",gap:0,position:"relative",justifyContent:"center" }}>
            {[
              { n:"01", icon:"📝", t:"Create Account",  d:"Sign up free with your mobile number and OTP. Takes under 60 seconds." },
              { n:"02", icon:"🎯", t:"Add Your Goals",  d:"Add goals like Car, House, Laptop, Mobile with target amount and deadline." },
              { n:"03", icon:"💰", t:"Log & Track",     d:"Log your savings regularly. Watch your progress bar fill up toward your dream!" },
            ].map((s,i)=>(
              <div key={i} style={{ display:"flex",flexDirection:"column",alignItems:"center",flex:"1 1 220px",padding:"0 16px",position:"relative" }}>
                <div style={{ width:80,height:80,borderRadius:"50%",background:"linear-gradient(135deg,#3B82F6,#2563EB)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,boxShadow:"0 8px 24px #3B82F640",marginBottom:20,position:"relative",zIndex:1 }}>{s.icon}</div>
                <div style={{ position:"absolute",top:38,left:"60%",right:0,height:2,background:"#BFDBFE",zIndex:0,display:i<2?"block":"none" }} />
                <div style={{ fontSize:11,fontWeight:800,color:"#3B82F6",letterSpacing:1,marginBottom:6 }}>STEP {s.n}</div>
                <h3 style={{ fontSize:20,fontWeight:900,color:"#0F172A",margin:"0 0 10px" }}>{s.t}</h3>
                <p style={{ fontSize:14,color:"#64748B",lineHeight:1.7,margin:0 }}>{s.d}</p>
              </div>
            ))}
          </div>
          <button onClick={onSignup} style={{ ...primaryBtn(),marginTop:56,padding:"16px 48px",fontSize:17,borderRadius:16,width:"auto",display:"inline-block" }}>
            Start Tracking Free →
          </button>
        </div>
      </section>

      {/* ── GOAL CATEGORIES SHOWCASE ── */}
      <section style={{ padding:"80px 24px",background:"#fff" }}>
        <div style={{ maxWidth:900,margin:"0 auto",textAlign:"center" }}>
          <h2 style={{ fontSize:"clamp(24px,4vw,40px)",fontWeight:900,color:"#0F172A",margin:"0 0 16px",letterSpacing:-.5 }}>
            Save for <span style={{ color:"#3B82F6" }}>anything & everything</span>
          </h2>
          <p style={{ fontSize:16,color:"#64748B",margin:"0 0 44px" }}>10 goal categories covering all major purchases and life goals</p>
          <div style={{ display:"flex",flexWrap:"wrap",gap:16,justifyContent:"center" }}>
            {CATS.map(c=>(
              <div key={c.id} style={{ display:"flex",flexDirection:"column",alignItems:"center",gap:8,padding:"18px 20px",background:c.bg,borderRadius:20,border:`2px solid ${c.color}25`,minWidth:90,transition:"all .2s",cursor:"default" }}
                onMouseEnter={e=>{e.currentTarget.style.transform="scale(1.06)";e.currentTarget.style.boxShadow=`0 8px 20px ${c.color}30`;}}
                onMouseLeave={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="";}}>
                <span style={{ fontSize:34 }}>{c.emoji}</span>
                <span style={{ fontSize:12,fontWeight:700,color:"#475569" }}>{c.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ── */}
      <section id="testimonials" style={{ padding:"80px 24px",background:"#0F172A" }}>
        <div style={{ maxWidth:960,margin:"0 auto",textAlign:"center" }}>
          <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"rgba(16,185,129,0.15)",border:"1px solid rgba(16,185,129,0.3)",borderRadius:99,padding:"6px 16px",marginBottom:24 }}>
            <span style={{ fontSize:12,fontWeight:700,color:"#93C5FD",letterSpacing:.5 }}>⭐ LOVED BY THOUSANDS</span>
          </div>
          <h2 style={{ fontSize:"clamp(28px,5vw,44px)",fontWeight:900,color:"#fff",margin:"0 0 56px",letterSpacing:-.5 }}>Real stories from real savers</h2>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:20 }}>
            {testimonials.map((t,i)=>(
              <div key={i} style={{ background:"rgba(255,255,255,0.05)",borderRadius:24,padding:"28px 24px",textAlign:"left",border:"1px solid rgba(255,255,255,0.08)",backdropFilter:"blur(10px)" }}>
                <div style={{ fontSize:28,color:"#3B82F6",marginBottom:16,letterSpacing:2 }}>★★★★★</div>
                <p style={{ fontSize:15,color:"#CBD5E1",lineHeight:1.8,margin:"0 0 20px",fontStyle:"italic" }}>"{t.text}"</p>
                <div style={{ display:"flex",alignItems:"center",gap:12 }}>
                  <div style={{ width:44,height:44,borderRadius:"50%",background:"linear-gradient(135deg,#3B82F6,#2563EB)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20 }}>{t.avatar}</div>
                  <div>
                    <div style={{ fontWeight:800,color:"#fff",fontSize:15 }}>{t.name}</div>
                    <div style={{ fontSize:12,color:"#64748B" }}>{t.loc}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── DOWNLOAD CTA ── */}
      <section style={{ padding:"80px 24px",background:"linear-gradient(135deg,#0F172A,#1E3A8A,#1D4ED8)",textAlign:"center",position:"relative",overflow:"hidden" }}>
        <div style={{ position:"absolute",inset:0,background:"radial-gradient(circle at 30% 50%,rgba(16,185,129,0.15),transparent 60%),radial-gradient(circle at 70% 50%,rgba(52,211,153,0.1),transparent 60%)" }} />
        <div style={{ position:"relative",zIndex:1 }}>
          <img src={ICON_SRC} alt="" style={{ width:80,height:80,borderRadius:24,objectFit:"cover",marginBottom:20,boxShadow:"0 8px 32px rgba(0,0,0,0.3)" }} />
          <h2 style={{ fontSize:"clamp(28px,5vw,48px)",fontWeight:900,color:"#fff",margin:"0 0 16px",letterSpacing:-.5 }}>Ready to start saving?</h2>
          <p style={{ fontSize:18,color:"#BFDBFE",margin:"0 0 44px" }}>Join thousands of Indians already achieving their financial goals</p>
          <div style={{ display:"flex",flexWrap:"wrap",gap:16,justifyContent:"center",marginBottom:40 }}>
            <button onClick={onSignup} style={{ ...primaryBtn(),padding:"16px 44px",fontSize:18,borderRadius:16,background:"#fff",color:"#1E3A8A",boxShadow:"0 8px 32px rgba(0,0,0,0.2)",width:"auto" }}>
              ✨ Create Free Account
            </button>
            <button onClick={onLogin} style={{ padding:"16px 44px",borderRadius:16,border:"2px solid rgba(255,255,255,0.3)",background:"rgba(255,255,255,0.1)",color:"#fff",fontWeight:700,fontSize:18,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",backdropFilter:"blur(10px)" }}>
              Login
            </button>
          </div>
          {/* App Store Badges */}
          <div style={{ display:"flex",flexWrap:"wrap",gap:12,justifyContent:"center" }}>
            <div onClick={()=>alert("iOS App coming soon!")} style={{ display:"flex",alignItems:"center",gap:12,background:"rgba(0,0,0,0.3)",borderRadius:16,padding:"12px 24px",border:"1px solid rgba(255,255,255,0.2)",cursor:"pointer",backdropFilter:"blur(10px)",transition:"all .2s" }}
              onMouseEnter={e=>{e.currentTarget.style.background="rgba(0,0,0,0.45)";}}
              onMouseLeave={e=>{e.currentTarget.style.background="rgba(0,0,0,0.3)";}}>
              <div style={{ fontSize:32 }}>🍎</div>
              <div style={{ textAlign:"left" }}>
                <div style={{ fontSize:11,color:"#94A3B8",fontWeight:600 }}>Download on the</div>
                <div style={{ fontSize:20,fontWeight:900,color:"#fff",lineHeight:1 }}>App Store</div>
                <div style={{ fontSize:11,color:"#93C5FD",fontWeight:600,marginTop:2 }}>⭐ 4.9 • 2K Ratings</div>
              </div>
            </div>
            <div onClick={()=>alert("Android App coming soon!")} style={{ display:"flex",alignItems:"center",gap:12,background:"rgba(0,0,0,0.3)",borderRadius:16,padding:"12px 24px",border:"1px solid rgba(255,255,255,0.2)",cursor:"pointer",backdropFilter:"blur(10px)",transition:"all .2s" }}
              onMouseEnter={e=>{e.currentTarget.style.background="rgba(0,0,0,0.45)";}}
              onMouseLeave={e=>{e.currentTarget.style.background="rgba(0,0,0,0.3)";}}>
              <div style={{ fontSize:32 }}>▶️</div>
              <div style={{ textAlign:"left" }}>
                <div style={{ fontSize:11,color:"#94A3B8",fontWeight:600 }}>GET IT ON</div>
                <div style={{ fontSize:20,fontWeight:900,color:"#fff",lineHeight:1 }}>Google Play</div>
                <div style={{ fontSize:11,color:"#93C5FD",fontWeight:600,marginTop:2 }}>⭐ 4.8 • 8K Downloads</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      {/* ── ADD TO HOME SCREEN (PWA) ── */}
      <section style={{ padding:"60px 24px",background:"linear-gradient(135deg,#EFF6FF 0%,#DBEAFE 100%)" }}>
        <div style={{ maxWidth:960,margin:"0 auto",textAlign:"center" }}>
          <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"#fff",border:"1px solid #BFDBFE",borderRadius:99,padding:"6px 16px",marginBottom:24 }}>
            <span>📲</span>
            <span style={{ fontSize:12,fontWeight:700,color:"#2563EB",letterSpacing:.5 }}>INSTALL APP</span>
          </div>
          <h2 style={{ fontSize:"clamp(26px,5vw,40px)",fontWeight:900,color:"#0F172A",margin:"0 0 12px",letterSpacing:-.5 }}>Add to Your Home Screen</h2>
          <p style={{ fontSize:16,color:"#64748B",margin:"0 0 40px",lineHeight:1.7 }}>Use Savings Tracker like a native app — no app store needed. Works on iPhone and Android.</p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:20,textAlign:"left" }}>
            {/* iOS */}
            <div style={{ background:"#fff",borderRadius:24,padding:28,boxShadow:"0 4px 24px rgba(0,0,0,0.08)",border:"1.5px solid #DBEAFE" }}>
              <div style={{ display:"flex",alignItems:"center",gap:12,marginBottom:20 }}>
                <div style={{ width:48,height:48,borderRadius:14,background:"linear-gradient(135deg,#000,#333)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:26 }}>🍎</div>
                <div><div style={{ fontWeight:900,fontSize:17,color:"#0F172A" }}>iPhone / iPad</div><div style={{ fontSize:12,color:"#64748B" }}>iOS Safari</div></div>
              </div>
              {[["1️⃣","Open in Safari","Tap the Share button (□↑) at the bottom"],["2️⃣","Add to Home Screen","Scroll down and tap 'Add to Home Screen'"],["3️⃣","Tap Add","Confirm by tapping Add — done! 🎉"]].map(([n,t,d])=>(
                <div key={n} style={{ display:"flex",gap:12,marginBottom:14,alignItems:"flex-start" }}>
                  <div style={{ fontSize:18,flexShrink:0,marginTop:1 }}>{n}</div>
                  <div><div style={{ fontWeight:700,fontSize:14,color:"#1A202C",marginBottom:2 }}>{t}</div><div style={{ fontSize:13,color:"#64748B",lineHeight:1.5 }}>{d}</div></div>
                </div>
              ))}
            </div>
            {/* Android */}
            <div style={{ background:"#fff",borderRadius:24,padding:28,boxShadow:"0 4px 24px rgba(0,0,0,0.08)",border:"1.5px solid #DBEAFE" }}>
              <div style={{ display:"flex",alignItems:"center",gap:12,marginBottom:20 }}>
                <div style={{ width:48,height:48,borderRadius:14,background:"linear-gradient(135deg,#3DDC84,#0A8053)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:26 }}>🤖</div>
                <div><div style={{ fontWeight:900,fontSize:17,color:"#0F172A" }}>Android</div><div style={{ fontSize:12,color:"#64748B" }}>Chrome browser</div></div>
              </div>
              {[["1️⃣","Open in Chrome","Visit savingstracker.pro in Chrome"],["2️⃣","Tap ⋮ Menu","Tap the three-dot menu in the top-right"],["3️⃣","Add to Home Screen","Tap 'Add to Home Screen' → Install 🎉"]].map(([n,t,d])=>(
                <div key={n} style={{ display:"flex",gap:12,marginBottom:14,alignItems:"flex-start" }}>
                  <div style={{ fontSize:18,flexShrink:0,marginTop:1 }}>{n}</div>
                  <div><div style={{ fontWeight:700,fontSize:14,color:"#1A202C",marginBottom:2 }}>{t}</div><div style={{ fontSize:13,color:"#64748B",lineHeight:1.5 }}>{d}</div></div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ marginTop:32,padding:"16px 24px",background:"rgba(37,99,235,0.08)",borderRadius:16,display:"inline-flex",alignItems:"center",gap:10 }}>
            <span style={{ fontSize:20 }}>💡</span>
            <span style={{ fontSize:14,color:"#1E40AF",fontWeight:600 }}>Works offline too! Your data is saved on your device.</span>
          </div>
        </div>
      </section>

      <footer style={{ background:"#0F172A",padding:"40px 24px 28px",borderTop:"1px solid #1E293B" }}>
        <div style={{ maxWidth:960,margin:"0 auto" }}>
          <div style={{ display:"flex",flexWrap:"wrap",justifyContent:"space-between",gap:32,marginBottom:40 }}>
            <div style={{ maxWidth:280 }}>
              <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:16 }}>
                <img src={LOGO_SRC} alt="Savings Tracker" style={{ height:40,objectFit:"contain",maxWidth:160,filter:"brightness(10)" }} />
              </div>
              <p style={{ fontSize:13,color:"#475569",lineHeight:1.8,margin:0 }}>India's most loved savings goal tracker. Free, beautiful and built for every Indian's financial dreams.</p>
            </div>
            <div>
              <div style={{ fontSize:12,fontWeight:800,color:"#64748B",letterSpacing:1,marginBottom:16 }}>LINKS</div>
              {["Terms of Use","Privacy Policy","Contact Us","Rate Us"].map(l=>(
                <div key={l} onClick={()=>alert(`${l} — Coming soon!`)} style={{ fontSize:14,color:"#94A3B8",marginBottom:10,cursor:"pointer",transition:"color .2s" }}
                  onMouseEnter={e=>{e.target.style.color="#3B82F6";}} onMouseLeave={e=>{e.target.style.color="#94A3B8";}}>{l}</div>
              ))}
            </div>
            <div>
              <div style={{ fontSize:12,fontWeight:800,color:"#64748B",letterSpacing:1,marginBottom:16 }}>GET THE APP</div>
              <div onClick={()=>alert("App Store coming soon!")} style={{ display:"flex",alignItems:"center",gap:8,marginBottom:12,cursor:"pointer" }}>
                <span style={{ fontSize:20 }}>🍎</span>
                <span style={{ fontSize:14,color:"#94A3B8" }}>iOS App Store</span>
              </div>
              <div onClick={()=>alert("Play Store coming soon!")} style={{ display:"flex",alignItems:"center",gap:8,cursor:"pointer" }}>
                <span style={{ fontSize:20 }}>▶️</span>
                <span style={{ fontSize:14,color:"#94A3B8" }}>Google Play Store</span>
              </div>
            </div>
          </div>
          <div style={{ borderTop:"1px solid #1E293B",paddingTop:24,display:"flex",flexWrap:"wrap",justifyContent:"space-between",alignItems:"center",gap:12 }}>
            <span style={{ fontSize:13,color:"#334155" }}>© 2026 Savings Tracker • Made with ❤️ in India</span>
            <a href="https://savingstracker.pro/" target="_blank" rel="noreferrer" style={{ fontSize:13,color:"#3B82F6",textDecoration:"none",fontWeight:700 }}>savingstracker.pro</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

/* ════════════════════════════════════════════════════════════════
   AUTH + APP (same as before, condensed)
═══════════════════════════════════════════════════════════════ */

/* ─ Modal ─ */
const Modal = ({ show, onClose, title, children, noPad }) => {
  if (!show) return null;
  return (
    <div onClick={onClose} style={{ position:"fixed",inset:0,background:"rgba(15,23,42,0.55)",zIndex:2000,display:"flex",alignItems:"flex-end",justifyContent:"center",backdropFilter:"blur(6px)" }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:"#fff",borderRadius:"28px 28px 0 0",width:"100%",maxWidth:480,maxHeight:"92vh",overflowY:"auto",animation:"slideUp .32s cubic-bezier(.4,0,.2,1)" }}>
        {!noPad&&<div style={{ padding:"22px 20px 0",display:"flex",justifyContent:"space-between",alignItems:"center" }}>
          <h2 style={{ margin:0,fontSize:19,fontWeight:800,color:"#1A202C",fontFamily:"'DM Sans',sans-serif" }}>{title}</h2>
          <button onClick={onClose} style={{ border:"none",background:"#F1F5F9",borderRadius:99,width:32,height:32,cursor:"pointer",fontSize:15,color:"#64748B" }}>✕</button>
        </div>}
        <div style={noPad?{}:{ padding:"16px 20px 32px" }}>{children}</div>
      </div>
    </div>
  );
};

/* ─ Country Picker ─ */
const CountryPicker = ({ selected, onSelect, onClose }) => {
  const [q,setQ]=useState("");
  const list = COUNTRIES.filter(c=>c.name.toLowerCase().includes(q.toLowerCase())||c.code.includes(q));
  return (
    <div style={{ padding:"20px 0 0" }}>
      <div style={{ padding:"0 20px 12px",display:"flex",justifyContent:"space-between",alignItems:"center" }}>
        <h2 style={{ margin:0,fontSize:19,fontWeight:800,color:"#1A202C",fontFamily:"'DM Sans',sans-serif" }}>Select Country</h2>
        <button onClick={onClose} style={{ border:"none",background:"#F1F5F9",borderRadius:99,width:32,height:32,cursor:"pointer",fontSize:15 }}>✕</button>
      </div>
      <div style={{ padding:"0 20px 12px" }}>
        <input style={{ ...inputStyle,paddingLeft:16 }} placeholder="Search country..." value={q} onChange={e=>setQ(e.target.value)} autoFocus />
      </div>
      <div style={{ maxHeight:380,overflowY:"auto" }}>
        {list.map(c=>(
          <div key={c.iso} onClick={()=>{onSelect(c);onClose();}} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"13px 20px",cursor:"pointer",borderBottom:"1px solid #F8FAFC",background:selected.iso===c.iso?"#EFF6FF":"#fff",transition:"background .15s" }}>
            <div style={{ display:"flex",alignItems:"center",gap:12 }}>
              <span style={{ fontSize:22 }}>{c.flag}</span>
              <span style={{ fontFamily:"'DM Sans',sans-serif",fontSize:15,color:"#1A202C",fontWeight:selected.iso===c.iso?700:400 }}>{c.name}</span>
            </div>
            <span style={{ fontFamily:"'DM Sans',sans-serif",fontSize:13,color:"#64748B",fontWeight:600 }}>{c.code}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

/* ─ Auth Screen ─ */
const AuthScreen = ({ onLogin, onBack, initialMode="login" }) => {
  const [mode,setMode]=useState(initialMode); // login | signup | forgot | resetpwd
  const [loginField,setLoginField]=useState(""); // phone or email
  const [pwd,setPwd]=useState("");
  const [name,setName]=useState("");
  const [phone,setPhone]=useState("");
  const [email,setEmail]=useState("");
  const [country,setCountry]=useState(COUNTRIES[0]);
  const [showCP,setShowCP]=useState(false);
  const [confirmPwd,setConfirmPwd]=useState("");
  const [forgotEmail,setForgotEmail]=useState("");
  const [newPwd,setNewPwd]=useState("");
  const [confirmNewPwd,setConfirmNewPwd]=useState("");
  const [err,setErr]=useState("");
  const [info,setInfo]=useState("");
  const [loading,setLoading]=useState(false);
  const [showPwd,setShowPwd]=useState(false);

  const go=(m)=>{setMode(m);setErr("");setInfo("");};

  // Find user by email across all accounts
  const findByEmail=(emailVal)=>{
    const u=LS.get("st_users")||{};
    return Object.values(u).find(usr=>usr.email&&usr.email.toLowerCase()===emailVal.toLowerCase().trim());
  };

  const validateEmail=(e)=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  // ── SIGNUP ──────────────────────────────────────────────────────
  const handleSignup=()=>{
    setErr(""); setInfo("");
    if(!name.trim()) return setErr("Please enter your full name.");
    if(phone.length<7) return setErr("Please enter a valid phone number.");
    if(!email.trim()||!validateEmail(email)) return setErr("Please enter a valid email address.");
    if(pwd.length<6) return setErr("Password must be at least 6 characters.");
    if(pwd!==confirmPwd) return setErr("Passwords do not match.");
    const fp=mkPhone(country.code,phone);
    const u=LS.get("st_users")||{};
    if(u[fp]) return setErr("Phone already registered. Please login.");
    if(findByEmail(email)) return setErr("Email already registered. Please login.");
    setLoading(true);
    setTimeout(()=>{
      const nu={phone:fp,name:name.trim(),email:email.trim().toLowerCase(),password:pwd,photo:null,createdAt:new Date().toISOString()};
      u[fp]=nu;
      LS.set("st_users",u);
      LS.set(`st_goals_${fp}`,[]);
      LS.set("st_session",fp);
      setLoading(false);
      onLogin(nu);
    },600);
  };

  // ── LOGIN ──────────────────────────────────────────────────────
  const handleLogin=()=>{
    setErr(""); setInfo("");
    if(!loginField.trim()) return setErr("Enter your phone number or email.");
    if(!pwd) return setErr("Enter your password.");
    const u=LS.get("st_users")||{};
    let usr=null;
    // Try as phone
    const fp=mkPhone(country.code, loginField.replace(/\D/g,""));
    if(u[fp]) usr=u[fp];
    // Try as email
    if(!usr) usr=findByEmail(loginField);
    if(!usr) return setErr("Account not found. Please sign up first.");
    if(usr.password!==pwd) return setErr("Incorrect password. Try again.");
    LS.set("st_session",usr.phone);
    onLogin(usr);
  };

  // ── FORGOT PASSWORD ──────────────────────────────────────────────────────
  const handleForgotSend=()=>{
    setErr(""); setInfo("");
    if(!forgotEmail.trim()||!validateEmail(forgotEmail)) return setErr("Enter a valid email address.");
    const usr=findByEmail(forgotEmail);
    if(!usr) return setErr("No account found with this email.");
    setLoading(true);
    setTimeout(()=>{
      setLoading(false);
      // Simulate email sent (in production: call real email API)
      setInfo(`✅ Reset link sent to ${forgotEmail}. Check your inbox (and spam folder).`);
      // Store reset token
      const token="rst_"+Date.now();
      const u=LS.get("st_users")||{};
      u[usr.phone]={...u[usr.phone],resetToken:token,resetEmail:forgotEmail.trim().toLowerCase()};
      LS.set("st_users",u);
      setTimeout(()=>go("resetpwd"),2000);
    },1200);
  };

  // ── RESET PASSWORD ──────────────────────────────────────────────────────
  const handleResetPwd=()=>{
    setErr("");
    if(newPwd.length<6) return setErr("Password must be at least 6 characters.");
    if(newPwd!==confirmNewPwd) return setErr("Passwords do not match.");
    const usr=findByEmail(forgotEmail);
    if(!usr) return setErr("Session expired. Please start again.");
    const u=LS.get("st_users")||{};
    u[usr.phone]={...u[usr.phone],password:newPwd,resetToken:null};
    LS.set("st_users",u);
    LS.set("st_session",usr.phone);
    onLogin({...usr,password:newPwd});
  };

  // ── SHARED UI PIECES ──────────────────────────────────────────────────────
  const eyeBtn=(show,toggle)=>(
    <button type="button" onClick={toggle} style={{ position:"absolute",right:14,top:"50%",transform:"translateY(-50%)",border:"none",background:"none",cursor:"pointer",fontSize:18,color:"#94A3B8",padding:0 }}>{show?"🙈":"👁️"}</button>
  );

  const pwdField=(label,val,set,show,toggleShow,placeholder="Password")=>(
    <div style={{ marginBottom:16 }}>
      <label style={labelStyle}>{label}</label>
      <div style={{ position:"relative" }}>
        <input style={inputStyle} type={show?"text":"password"} value={val} onChange={e=>set(e.target.value)} placeholder={placeholder} autoComplete="off"/>
        {eyeBtn(show,toggleShow)}
      </div>
    </div>
  );

  const [showPwd2,setShowPwd2]=useState(false);
  const [showPwd3,setShowPwd3]=useState(false);
  const [showPwd4,setShowPwd4]=useState(false);

  const wrapPage=(title,subtitle,body)=>(
    <div style={{ minHeight:"100vh",background:"linear-gradient(160deg,#0F172A 0%,#1E3A8A 45%,#1D4ED8 100%)",display:"flex",flexDirection:"column",fontFamily:"'DM Sans',sans-serif" }}>
      {/* Header */}
      <div style={{ padding:"52px 24px 36px",textAlign:"center",position:"relative" }}>
        <button onClick={onBack} style={{ position:"absolute",top:20,left:20,border:"none",background:"rgba(255,255,255,0.12)",borderRadius:10,width:36,height:36,cursor:"pointer",fontSize:18,color:"#fff",backdropFilter:"blur(10px)" }}>←</button>
        <img src={ICON_SRC} alt="" style={{ width:60,height:60,borderRadius:18,objectFit:"cover",margin:"0 auto 14px",display:"block",boxShadow:"0 4px 20px rgba(0,0,0,0.3)" }}/>
        <h1 style={{ color:"#fff",fontSize:24,fontWeight:900,margin:"0 0 6px",letterSpacing:-.3 }}>{title}</h1>
        <p style={{ color:"#BFDBFE",fontSize:14,margin:0 }}>{subtitle}</p>
      </div>
      {/* Card */}
      <div style={{ flex:1,background:"#fff",borderRadius:"28px 28px 0 0",padding:"28px 24px 40px",overflowY:"auto" }}>
        {err&&<div style={{ background:"#FEF2F2",border:"1px solid #FECACA",borderRadius:12,padding:"12px 16px",marginBottom:16,color:"#DC2626",fontSize:14,fontWeight:600,display:"flex",alignItems:"center",gap:8 }}>⚠️ {err}</div>}
        {info&&<div style={{ background:"#F0FDF4",border:"1px solid #BBF7D0",borderRadius:12,padding:"12px 16px",marginBottom:16,color:"#16A34A",fontSize:14,fontWeight:600 }}>{info}</div>}
        {body}
      </div>
    </div>
  );

  const phoneBlock=(
    <div style={{ marginBottom:16 }}>
      <label style={labelStyle}>Phone Number</label>
      <div style={{ display:"flex",gap:8 }}>
        <button type="button" onClick={()=>setShowCP(true)} style={{ display:"flex",alignItems:"center",gap:6,padding:"0 14px",background:"#F8FAFC",border:"1.5px solid #E2E8F0",borderRadius:12,cursor:"pointer",fontSize:14,fontWeight:700,color:"#1A202C",whiteSpace:"nowrap",height:52,flexShrink:0 }}>
          <span style={{ fontSize:20 }}>{country.flag}</span>
          <span>{country.code}</span>
          <span style={{ color:"#94A3B8",fontSize:11 }}>▼</span>
        </button>
        <input style={{ ...inputStyle,flex:1 }} type="tel" value={phone} onChange={e=>setPhone(e.target.value.replace(/\D/g,""))} placeholder="Mobile number" autoComplete="tel"/>
      </div>
      {showCP&&<Modal show onClose={()=>setShowCP(false)} title="Select Country" noPad><CountryPicker selected={country} onSelect={c=>setCountry(c)} onClose={()=>setShowCP(false)}/></Modal>}
    </div>
  );

  // ── SIGNUP PAGE ──────────────────────────────────────────────────────
  if(mode==="signup") return wrapPage("Create Account","Join thousands saving smarter",(
    <>
      <div style={{ marginBottom:16 }}><label style={labelStyle}>Full Name</label><input style={inputStyle} value={name} onChange={e=>setName(e.target.value)} placeholder="Your full name" autoComplete="name"/></div>
      {phoneBlock}
      <div style={{ marginBottom:16 }}><label style={labelStyle}>Email Address</label><input style={inputStyle} type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" autoComplete="email"/></div>
      {pwdField("Password",pwd,setPwd,showPwd,()=>setShowPwd(p=>!p),"Min 6 characters")}
      {pwdField("Confirm Password",confirmPwd,setConfirmPwd,showPwd2,()=>setShowPwd2(p=>!p),"Re-enter password")}
      <button onClick={handleSignup} style={primaryBtn()} disabled={loading}>{loading?"Creating account…":"Create Account →"}</button>
      <p style={{ textAlign:"center",marginTop:16,color:"#64748B",fontSize:14 }}>Already have an account? <span onClick={()=>go("login")} style={{ color:"#3B82F6",fontWeight:700,cursor:"pointer" }}>Login</span></p>
    </>
  ));

  // ── LOGIN PAGE ──────────────────────────────────────────────────────
  if(mode==="login") return wrapPage("Welcome Back!","Login to your account",(
    <>
      <div style={{ marginBottom:16 }}>
        <label style={labelStyle}>Phone Number or Email</label>
        <input style={inputStyle} value={loginField} onChange={e=>setLoginField(e.target.value)} placeholder="Phone or email address" autoComplete="username"/>
      </div>
      {pwdField("Password",pwd,setPwd,showPwd3,()=>setShowPwd3(p=>!p))}
      <div style={{ textAlign:"right",marginTop:-8,marginBottom:16 }}>
        <span onClick={()=>{go("forgot");setForgotEmail(validateEmail(loginField)?loginField:"");}} style={{ color:"#3B82F6",fontSize:13,fontWeight:600,cursor:"pointer" }}>Forgot password?</span>
      </div>
      <button onClick={handleLogin} style={primaryBtn()} disabled={loading}>{loading?"Logging in…":"Login →"}</button>
      <p style={{ textAlign:"center",marginTop:16,color:"#64748B",fontSize:14 }}>New here? <span onClick={()=>go("signup")} style={{ color:"#3B82F6",fontWeight:700,cursor:"pointer" }}>Create Account</span></p>
    </>
  ));

  // ── FORGOT PASSWORD ──────────────────────────────────────────────────────
  if(mode==="forgot") return wrapPage("Reset Password","We'll send a reset link to your email",(
    <>
      <div style={{ marginBottom:16 }}><label style={labelStyle}>Email Address</label><input style={inputStyle} type="email" value={forgotEmail} onChange={e=>setForgotEmail(e.target.value)} placeholder="you@example.com" autoComplete="email"/></div>
      <button onClick={handleForgotSend} style={primaryBtn()} disabled={loading}>{loading?"Sending reset link…":"Send Reset Link →"}</button>
      <p style={{ textAlign:"center",marginTop:12,color:"#64748B",fontSize:14 }}><span onClick={()=>go("login")} style={{ color:"#3B82F6",fontWeight:700,cursor:"pointer" }}>← Back to Login</span></p>
    </>
  ));

  // ── RESET PASSWORD ──────────────────────────────────────────────────────
  if(mode==="resetpwd") return wrapPage("Set New Password","Choose a strong new password",(
    <>
      {pwdField("New Password",newPwd,setNewPwd,showPwd4,()=>setShowPwd4(p=>!p),"Min 6 characters")}
      {pwdField("Confirm New Password",confirmNewPwd,setConfirmNewPwd,showPwd2,()=>setShowPwd2(p=>!p),"Re-enter new password")}
      <button onClick={handleResetPwd} style={primaryBtn()}>Reset & Login →</button>
    </>
  ));

  return null;
};

/* ─ Settings Menu ─ */
const SettingsMenu = ({ show,onClose,user,onLogout,onEditProfile }) => (
  <Modal show={show} onClose={onClose} title="Settings">
    {/* Dark Profile Card */}
    <div style={{ background:"linear-gradient(135deg,#0F172A 0%,#1E3A8A 100%)",borderRadius:20,padding:"20px 18px",marginBottom:18 }}>
      <div style={{ display:"flex",alignItems:"center",gap:12 }}>
        <div style={{ width:58,height:58,borderRadius:"50%",background:"linear-gradient(135deg,#3B82F6,#60A5FA)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,color:"#fff",fontWeight:900,overflow:"hidden",flexShrink:0,border:"3px solid rgba(255,255,255,0.2)" }}>
          {user?.photo?<img src={user.photo} alt="" style={{ width:"100%",height:"100%",objectFit:"cover" }}/>:(user?.name?.[0]?.toUpperCase()||"U")}
        </div>
        <div style={{ flex:1,minWidth:0 }}>
          <div style={{ fontWeight:900,fontSize:17,color:"#fff",fontFamily:"'DM Sans',sans-serif",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{user?.name||"User"}</div>
          <div style={{ fontSize:12,color:"#93C5FD",marginTop:3 }}>📱 {user?.phone||"—"}</div>
          <div style={{ fontSize:12,color:"#93C5FD",marginTop:2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>✉️ {user?.email||"No email set"}</div>
        </div>
        <button onClick={()=>{onEditProfile();onClose();}} style={{ border:"1.5px solid rgba(255,255,255,0.25)",background:"rgba(255,255,255,0.1)",borderRadius:10,cursor:"pointer",fontSize:13,fontWeight:700,color:"#fff",fontFamily:"'DM Sans',sans-serif",padding:"8px 12px",flexShrink:0 }}>Edit</button>
      </div>
      <div style={{ borderTop:"1px solid rgba(255,255,255,0.1)",marginTop:14,paddingTop:12,display:"flex",justifyContent:"space-between" }}>
        <div>
          <div style={{ fontSize:10,color:"rgba(255,255,255,0.45)",fontWeight:700,letterSpacing:.5 }}>MEMBER SINCE</div>
          <div style={{ fontSize:12,color:"#fff",fontWeight:700,marginTop:2 }}>{user?.createdAt?new Date(user.createdAt).toLocaleDateString("en-IN",{month:"long",year:"numeric"}):"—"}</div>
        </div>
        <div style={{ textAlign:"right" }}>
          <div style={{ fontSize:10,color:"rgba(255,255,255,0.45)",fontWeight:700,letterSpacing:.5 }}>APP VERSION</div>
          <div style={{ fontSize:12,color:"#fff",fontWeight:700,marginTop:2 }}>v2.0.0</div>
        </div>
      </div>
    </div>

    {/* Ad-free badge */}
    <div style={{ background:"linear-gradient(135deg,#F0FDF4,#DCFCE7)",borderRadius:14,padding:"12px 16px",marginBottom:16,display:"flex",alignItems:"center",gap:12,border:"1px solid #BBF7D0" }}>
      <span style={{ fontSize:22 }}>🎉</span>
      <div><div style={{ fontWeight:800,fontSize:13,color:"#15803D",fontFamily:"'DM Sans',sans-serif" }}>100% Free & Ad-Free Forever</div>
      <div style={{ fontSize:12,color:"#16A34A",marginTop:1 }}>No ads • No subscriptions • No payments ever</div></div>
    </div>

    {[{icon:"📋",label:"Terms of Use"},{icon:"🔒",label:"Privacy Policy"},{icon:"📧",label:"Contact Us"},{icon:"⭐",label:"Rate Us"}].map(item=>(
      <div key={item.label} onClick={()=>alert(`${item.label} — Coming soon!`)} style={{ display:"flex",alignItems:"center",gap:14,padding:"14px 4px",borderBottom:"1px solid #F8FAFC",cursor:"pointer" }}>
        <div style={{ width:40,height:40,borderRadius:12,background:"#F1F5F9",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18 }}>{item.icon}</div>
        <span style={{ fontFamily:"'DM Sans',sans-serif",fontSize:15,fontWeight:600,color:"#1A202C" }}>{item.label}</span>
        <span style={{ marginLeft:"auto",color:"#CBD5E1",fontSize:16 }}>›</span>
      </div>
    ))}

    <div onClick={()=>window.open("https://buymeacoffee.com","_blank")} style={{ display:"flex",alignItems:"center",gap:14,padding:"14px 4px",borderBottom:"1px solid #F8FAFC",cursor:"pointer" }}>
      <div style={{ width:40,height:40,borderRadius:12,background:"#FFF8E1",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18 }}>☕</div>
      <div style={{ flex:1 }}>
        <div style={{ fontFamily:"'DM Sans',sans-serif",fontSize:15,fontWeight:700,color:"#1A202C" }}>Buy Me a Coffee</div>
        <div style={{ fontSize:12,color:"#94A3B8",marginTop:1 }}>Support us to keep the app free & running</div>
      </div>
      <span style={{ color:"#CBD5E1",fontSize:16 }}>›</span>
    </div>

    <button onClick={onLogout} style={{ ...primaryBtn("#EF4444"),marginTop:20 }}>🚪 Logout</button>
  </Modal>
);

/* ─ Edit Profile ─ */
const EditProfile = ({ user,onSave,onClose }) => {
  const [name,setName]=useState(user?.name||""); const [email,setEmail]=useState(user?.email||""); const [photo,setPhoto]=useState(user?.photo||null);
  const fr=useRef();
  return (
    <Modal show onClose={onClose} title="Edit Profile">
      <div style={{ display:"flex",flexDirection:"column",alignItems:"center",marginBottom:20 }}>
        <div onClick={()=>fr.current.click()} style={{ width:88,height:88,borderRadius:"50%",background:"linear-gradient(135deg,#3B82F6,#2563EB)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:36,color:"#fff",cursor:"pointer",overflow:"hidden",position:"relative",boxShadow:"0 4px 20px #3B82F645" }}>
          {photo?<img src={photo} alt="" style={{ width:"100%",height:"100%",objectFit:"cover" }}/>:(name[0]||"U")}
          <div style={{ position:"absolute",bottom:0,left:0,right:0,background:"rgba(0,0,0,0.4)",padding:"6px 0",textAlign:"center",fontSize:12 }}>📷</div>
        </div>
        <input ref={fr} type="file" accept="image/*" style={{ display:"none" }} onChange={e=>{ const f=e.target.files[0];if(!f)return;const r=new FileReader();r.onload=ev=>setPhoto(ev.target.result);r.readAsDataURL(f); }} />
        <p style={{ fontSize:12,color:"#94A3B8",marginTop:8 }}>Tap to change photo</p>
      </div>
      <div style={{ marginBottom:16 }}><label style={labelStyle}>Full Name</label><input style={inputStyle} value={name} onChange={e=>setName(e.target.value)} /></div>
      <div style={{ marginBottom:16 }}><label style={labelStyle}>Phone</label><input style={{ ...inputStyle,background:"#F8FAFC",color:"#94A3B8" }} value={user?.phone} disabled /></div>
      <div style={{ marginBottom:20 }}><label style={labelStyle}>Email</label><input style={inputStyle} type="email" value={email} onChange={e=>setEmail(e.target.value)} /></div>
      <button onClick={()=>onSave({name,email,photo})} style={primaryBtn()}>Save Changes ✓</button>
    </Modal>
  );
};

/* ─ Progress Bar ─ */
const PBar = ({ pct,color }) => (
  <div style={{ background:"#EEF1F5",borderRadius:99,height:7,overflow:"hidden",margin:"6px 0" }}>
    <div style={{ height:"100%",borderRadius:99,background:`linear-gradient(90deg,${color}80,${color})`,width:`${Math.min(pct,100)}%`,transition:"width .8s cubic-bezier(.4,0,.2,1)" }} />
  </div>
);

/* ─ Circular Progress ─ */
const CProg = ({ pct,color,size=150,emoji,sw=11 }) => {
  const r=(size-sw*2)/2,circ=2*Math.PI*r;
  return (
    <div style={{ position:"relative",width:size,height:size,display:"flex",alignItems:"center",justifyContent:"center" }}>
      <svg width={size} height={size} style={{ transform:"rotate(-90deg)",position:"absolute" }}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="#E8ECF0" strokeWidth={sw}/>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={sw} strokeDasharray={circ} strokeDashoffset={circ-(Math.min(pct,100)/100)*circ} strokeLinecap="round" style={{ transition:"stroke-dashoffset .9s cubic-bezier(.4,0,.2,1)" }}/>
      </svg>
      <div style={{ display:"flex",flexDirection:"column",alignItems:"center",gap:2 }}>
        <span style={{ fontSize:size*.27 }}>{emoji}</span>
        <span style={{ fontSize:13,fontWeight:900,color:"#1A202C",fontFamily:"'DM Sans',sans-serif" }}>{Math.round(pct)}%</span>
      </div>
    </div>
  );
};

/* ─ Goal Form ─ */
const GoalForm = ({ initial,onSave,onCancel }) => {
  const [f,setF]=useState(initial||{title:"",description:"",category:"car",target:"",saved:"",deadline:""});
  const s=(k,v)=>setF(p=>({...p,[k]:v})); const cat=getCat(f.category);
  return (
    <div>
      <div style={{ marginBottom:16 }}>
        <label style={labelStyle}>Category</label>
        <div style={{ display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:8 }}>
          {CATS.map(c=>(
            <button key={c.id} onClick={()=>s("category",c.id)} style={{ border:f.category===c.id?`2px solid ${c.color}`:"2px solid transparent",background:f.category===c.id?c.bg:"#F7F9FB",borderRadius:14,padding:"9px 4px",cursor:"pointer",textAlign:"center",transition:"all .2s" }}>
              <div style={{ fontSize:22 }}>{c.emoji}</div>
              <div style={{ fontSize:10,color:"#94A3B8",marginTop:2,fontFamily:"'DM Sans',sans-serif" }}>{c.label}</div>
            </button>
          ))}
        </div>
      </div>
      <div style={{ marginBottom:14 }}><label style={labelStyle}>Goal Title</label><input style={inputStyle} value={f.title} onChange={e=>s("title",e.target.value)} placeholder={`e.g. My ${cat.label}`} /></div>
      <div style={{ marginBottom:14 }}><label style={labelStyle}>Description</label><input style={inputStyle} value={f.description} onChange={e=>s("description",e.target.value)} placeholder="Short description" /></div>
      <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14 }}>
        <div><label style={labelStyle}>Target (₹)</label><input style={inputStyle} type="number" value={f.target} onChange={e=>s("target",e.target.value)} placeholder="120000" /></div>
        <div><label style={labelStyle}>Already Saved (₹)</label><input style={inputStyle} type="number" value={f.saved} onChange={e=>s("saved",e.target.value)} placeholder="0" /></div>
      </div>
      <div style={{ marginBottom:20 }}><label style={labelStyle}>Deadline</label><input style={inputStyle} type="date" value={f.deadline} onChange={e=>s("deadline",e.target.value)} /></div>
      <div style={{ display:"flex",gap:10 }}>
        <button onClick={onCancel} style={{ flex:1,padding:14,borderRadius:14,border:"1.5px solid #E2E8F0",background:"#fff",cursor:"pointer",fontWeight:600,color:"#64748B",fontFamily:"'DM Sans',sans-serif",fontSize:15 }}>Cancel</button>
        <button onClick={()=>onSave(f)} style={{ ...primaryBtn(),flex:2 }}>Save Goal ✓</button>
      </div>
    </div>
  );
};

/* ─ Reorder ─ */
const Reorder = ({ goals,onChange,onDone }) => {
  const [items,setItems]=useState(goals); const di=useRef(null); const [drag,setDrag]=useState(null);
  const move=(a,b)=>{ const arr=[...items];const [m]=arr.splice(a,1);arr.splice(b,0,m);setItems(arr); };
  return (
    <div style={{ padding:"8px 0" }}>
      <p style={{ fontSize:13,color:"#94A3B8",textAlign:"center",margin:"0 0 12px",fontFamily:"'DM Sans',sans-serif" }}>Drag ☰ or use ▲▼ to reorder your goals</p>
      {items.map((g,i)=>{ const cat=getCat(g.category); return (
        <div key={g.id} draggable onDragStart={()=>{di.current=i;setDrag(i);}} onDragEnd={()=>setDrag(null)} onDragOver={e=>{e.preventDefault();if(di.current!==i){move(di.current,i);di.current=i;}}} style={{ display:"flex",alignItems:"center",gap:12,padding:"12px 14px",margin:"0 0 8px",background:drag===i?"#EFF6FF":"#fff",borderRadius:16,border:`1.5px solid ${drag===i?"#BFDBFE":"#F0F4F8"}`,cursor:"grab",userSelect:"none",transition:"all .15s" }}>
          <span style={{ color:"#CBD5E1",fontSize:20 }}>☰</span>
          <div style={{ width:38,height:38,borderRadius:12,background:cat.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20 }}>{cat.emoji}</div>
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:700,fontSize:14,color:"#1A202C",fontFamily:"'DM Sans',sans-serif" }}>{g.title}</div>
            <div style={{ fontSize:12,color:"#94A3B8" }}>{formatINR(g.saved)} / {formatINR(g.target)}</div>
          </div>
          <div style={{ display:"flex",flexDirection:"column",gap:4 }}>
            <button onClick={()=>{if(i>0)move(i,i-1);}} style={{ border:"none",background:"#F1F5F9",borderRadius:8,width:28,height:28,cursor:"pointer",fontSize:12 }}>▲</button>
            <button onClick={()=>{if(i<items.length-1)move(i,i+1);}} style={{ border:"none",background:"#F1F5F9",borderRadius:8,width:28,height:28,cursor:"pointer",fontSize:12 }}>▼</button>
          </div>
        </div>
      );})}
      <button onClick={()=>{onChange(items);onDone();}} style={primaryBtn()}>Save Order ✓</button>
    </div>
  );
};

/* ─ Goal Card ─ */
const GoalCard = ({ goal,onClick }) => {
  const cat=getCat(goal.category); const pct=goal.target>0?Math.min((goal.saved/goal.target)*100,100):0;
  const dl=calcDays(goal.deadline); const ok=pct>=100; const bc=ok?"#3B82F6":pct>0?cat.color:"#EF4444";
  return (
    <div onClick={onClick} style={{ background:"#fff",borderRadius:20,padding:"16px 18px 14px",boxShadow:"0 2px 12px rgba(0,0,0,0.06)",cursor:"pointer",border:"1.5px solid #F0F4F8",transition:"all .2s",fontFamily:"'DM Sans',sans-serif" }}
      onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 8px 24px rgba(0,0,0,0.10)";}}
      onMouseLeave={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="0 2px 12px rgba(0,0,0,0.06)";}}>
      <div style={{ display:"flex",alignItems:"flex-start",justifyContent:"space-between" }}>
        <div style={{ display:"flex",alignItems:"center",gap:12 }}>
          <div style={{ width:50,height:50,borderRadius:16,background:cat.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26 }}>{cat.emoji}</div>
          <div>
            <div style={{ fontWeight:800,fontSize:16,color:"#1A202C" }}>{goal.title}</div>
            <div style={{ fontSize:12,color:"#94A3B8",fontStyle:"italic" }}>{goal.description}</div>
            <div style={{ fontSize:11,color:"#CBD5E1",marginTop:1 }}>Target: {formatINR(goal.target)}</div>
          </div>
        </div>
        <div style={{ textAlign:"right" }}>
          <span style={{ fontSize:14,fontWeight:900,color:bc }}>{Math.round(pct)}%</span>
          {!ok&&dl>=0&&dl<=30&&<div style={{ fontSize:11,color:"#EF4444",fontWeight:700 }}>⚡ {formatTimeLeft(dl)}</div>}
        </div>
      </div>
      <div style={{ marginTop:10 }}>
        <div style={{ fontSize:12,color:"#94A3B8",marginBottom:2 }}>{formatINR(goal.saved)} of {formatINR(goal.target)}</div>
        <PBar pct={pct} color={bc}/>
        <div style={{ display:"flex",justifyContent:"space-between",marginTop:4 }}>
          <span style={{ fontSize:13,fontWeight:700,color:bc }}>{ok?"✅ Achieved!":(`Saved: ${formatINR(goal.saved)}`)}</span>
          <span style={{ fontSize:11,color:"#94A3B8" }}>Rem: {formatINR(Math.max(0,goal.target-goal.saved))}</span>
        </div>
      </div>
    </div>
  );
};

/* ─ Goal Detail ─ */
const GoalDetail = ({ goal,onBack,onEdit,onLog,onDelete }) => {
  const [tab,setTab]=useState("details"); const cat=getCat(goal.category);
  const pct=goal.target>0?Math.min((goal.saved/goal.target)*100,100):0;
  const dl=calcDays(goal.deadline); const cdays=Math.floor((Date.now()-new Date(goal.createdAt))/86400000);
  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif",minHeight:"100vh",background:"#F7F9FC" }}>
      <div style={{ background:"#fff",padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid #F0F4F8",position:"sticky",top:0,zIndex:10 }}>
        <button onClick={onBack} style={{ border:"none",background:"#F1F5F9",borderRadius:10,width:36,height:36,cursor:"pointer",fontSize:18 }}>←</button>
        <div style={{ display:"flex",gap:8 }}>
          <button onClick={onEdit} style={{ border:"1.5px solid #E2E8F0",background:"#fff",borderRadius:10,padding:"7px 14px",cursor:"pointer",fontSize:13,fontWeight:700,color:"#4A5568" }}>✏️ Edit</button>
          <button onClick={onDelete} style={{ border:"1.5px solid #FED7D7",background:"#FFF5F5",borderRadius:10,padding:"7px 14px",cursor:"pointer",fontSize:13,fontWeight:700,color:"#EF4444" }}>🗑️</button>
        </div>
      </div>
      <div style={{ background:"#fff",padding:"28px 20px 20px",display:"flex",flexDirection:"column",alignItems:"center" }}>
        <CProg pct={pct} color={cat.color} size={155} emoji={cat.emoji}/>
        <h1 style={{ margin:"16px 0 2px",fontSize:26,fontWeight:900,color:"#1A202C" }}>{goal.title}</h1>
        <p style={{ margin:0,color:"#94A3B8",fontSize:14,fontStyle:"italic" }}>{goal.description}</p>
      </div>
      <div style={{ background:"#fff",display:"flex",borderBottom:"2px solid #F0F4F8",marginBottom:12 }}>
        {["details","history"].map(t=>(
          <button key={t} onClick={()=>setTab(t)} style={{ flex:1,padding:14,border:"none",background:"none",cursor:"pointer",fontWeight:tab===t?900:500,fontSize:15,color:tab===t?"#1A202C":"#94A3B8",borderBottom:tab===t?`3px solid ${cat.color}`:"3px solid transparent",fontFamily:"'DM Sans',sans-serif",transition:"all .2s",textTransform:"capitalize" }}>
            {t[0].toUpperCase()+t.slice(1)}
          </button>
        ))}
      </div>
      <div style={{ padding:"0 16px 110px" }}>
        {tab==="details"?(
          <>
            <div style={{ background:"#fff",borderRadius:20,padding:20,marginBottom:12,boxShadow:"0 2px 12px rgba(0,0,0,0.06)" }}>
              <h3 style={{ margin:"0 0 14px",fontSize:15,fontWeight:800,color:"#1A202C" }}>💰 Savings</h3>
              <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8 }}>
                {[{l:"Saved",v:formatINR(goal.saved),c:"#3B82F6"},{l:"Remaining",v:formatINR(Math.max(0,goal.target-goal.saved)),c:cat.color},{l:"Goal",v:formatINR(goal.target),c:"#3B82F6"}].map(x=>(
                  <div key={x.l} style={{ textAlign:"center",background:"#F8FAFC",borderRadius:14,padding:"12px 6px" }}>
                    <div style={{ fontSize:15,fontWeight:800,color:x.c }}>{x.v}</div>
                    <div style={{ fontSize:11,color:"#94A3B8",marginTop:2 }}>{x.l}</div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ background:"#fff",borderRadius:20,padding:20,marginBottom:12,boxShadow:"0 2px 12px rgba(0,0,0,0.06)" }}>
              <h3 style={{ margin:"0 0 14px",fontSize:15,fontWeight:800,color:"#1A202C" }}>📅 Deadline</h3>
              <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8 }}>
                {[{l:"Elapsed",v:`${cdays}d`,c:"#3B82F6"},{l:"Time Left",v:formatTimeLeft(dl),c:dl<=30?"#EF4444":cat.color},{l:"Deadline",v:formatDate(goal.deadline),c:"#3B82F6"}].map(x=>(
                  <div key={x.l} style={{ textAlign:"center",background:"#F8FAFC",borderRadius:14,padding:"12px 6px" }}>
                    <div style={{ fontSize:14,fontWeight:800,color:x.c }}>{x.v}</div>
                    <div style={{ fontSize:11,color:"#94A3B8",marginTop:2 }}>{x.l}</div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ background:"#fff",borderRadius:20,padding:20,marginBottom:12,boxShadow:"0 2px 12px rgba(0,0,0,0.06)" }}>
              <h3 style={{ margin:"0 0 10px",fontSize:15,fontWeight:800,color:"#1A202C" }}>📊 Progress</h3>
              <div style={{ display:"flex",justifyContent:"space-between",fontSize:13,color:"#64748B",marginBottom:4 }}>
                <span>Overall</span><span style={{ fontWeight:900,color:cat.color }}>{Math.round(pct)}%</span>
              </div>
              <PBar pct={pct} color={cat.color}/>
              {dl>0&&goal.saved<goal.target&&<div style={{ marginTop:12,padding:14,background:cat.bg,borderRadius:14 }}>
                <div style={{ fontSize:12,color:cat.color,fontWeight:700 }}>💡 Monthly target to reach goal</div>
                <div style={{ fontSize:18,fontWeight:900,color:"#1A202C",marginTop:4 }}>{formatINR(Math.ceil((goal.target-goal.saved)/Math.max(1,Math.floor(dl/30))))} / month</div>
              </div>}
            </div>
          </>
        ):(
          <div style={{ background:"#fff",borderRadius:20,padding:20,boxShadow:"0 2px 12px rgba(0,0,0,0.06)" }}>
            <h3 style={{ margin:"0 0 14px",fontSize:15,fontWeight:800,color:"#1A202C" }}>History ({goal.history.length})</h3>
            {goal.history.length===0?<div style={{ textAlign:"center",padding:"32px 0",color:"#94A3B8" }}><div style={{ fontSize:40 }}>📋</div><div style={{ fontWeight:600,marginTop:8 }}>No transactions yet</div></div>
            :[...goal.history].reverse().map((h,i)=>(
              <div key={h.id} style={{ display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:i<goal.history.length-1?"1px solid #F8FAFC":"none" }}>
                <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                  <div style={{ width:38,height:38,borderRadius:12,background:cat.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18 }}>💰</div>
                  <div><div style={{ fontWeight:700,fontSize:14,color:"#1A202C" }}>{h.note||"Deposit"}</div><div style={{ fontSize:12,color:"#94A3B8" }}>{new Date(h.date).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"})}</div></div>
                </div>
                <div style={{ fontWeight:800,fontSize:15,color:"#3B82F6" }}>+{formatINR(h.amount)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div style={{ position:"fixed",bottom:0,left:0,right:0,background:"linear-gradient(to top,#fff 80%,transparent)",padding:"12px 20px 24px",maxWidth:480,margin:"0 auto" }}>
        <button onClick={onLog} style={{ ...primaryBtn(cat.color),width:"100%",fontSize:15,letterSpacing:.5 }}>+ LOG NEW AMOUNT</button>
      </div>
    </div>
  );
};

/* ─ Log Modal ─ */
const LogModal = ({ show,goal,onClose,onSave }) => {
  const [amt,setAmt]=useState(""); const [note,setNote]=useState("");
  if(!goal) return null;
  const cat=getCat(goal.category);
  return (
    <Modal show={show} onClose={onClose} title={`Log — ${goal.title}`}>
      <div style={{ textAlign:"center",marginBottom:16 }}><div style={{ fontSize:44 }}>{cat.emoji}</div><div style={{ fontSize:13,color:"#94A3B8",marginTop:4 }}>Remaining: <strong style={{ color:"#1A202C" }}>{formatINR(Math.max(0,goal.target-goal.saved))}</strong></div></div>
      <div style={{ marginBottom:14 }}><label style={labelStyle}>Amount (₹)</label><input style={{ ...inputStyle,fontSize:24,fontWeight:900,textAlign:"center",color:"#3B82F6" }} type="number" value={amt} onChange={e=>setAmt(e.target.value)} placeholder="0" /></div>
      <div style={{ marginBottom:20 }}><label style={labelStyle}>Note (optional)</label><input style={inputStyle} value={note} onChange={e=>setNote(e.target.value)} placeholder="e.g. Monthly savings" /></div>
      <button onClick={()=>{ if(Number(amt)>0){onSave(Number(amt),note);setAmt("");setNote("");} }} style={primaryBtn(cat.color)}>Add {amt?formatINR(amt):"₹0"}</button>
    </Modal>
  );
};

/* ════════════════════════════════════════════════════════════════
   MAIN APP DASHBOARD
═══════════════════════════════════════════════════════════════ */
const Dashboard = ({ user,onLogout }) => {
  const [goals,setGoals]=useState([]);
  const [view,setView]=useState("dash");
  const [selId,setSelId]=useState(null);
  const [showAdd,setShowAdd]=useState(false); const [showEdit,setShowEdit]=useState(false);
  const [showLog,setShowLog]=useState(false); const [showSettings,setShowSettings]=useState(false);
  const [showProfile,setShowProfile]=useState(false); const [showReorder,setShowReorder]=useState(false);
  const [nid,setNid]=useState(100);

  useEffect(()=>{ setGoals(LS.get(`st_goals_${user.phone}`)||[]); },[user.phone]); // eslint-disable-line
  const save=(g)=>{ setGoals(g);LS.set(`st_goals_${user.phone}`,g); };
  const sel=goals.find(g=>g.id===selId);

  const addGoal=(f)=>{ const cat=getCat(f.category);const ng={id:nid,category:f.category,title:f.title||cat.label,description:f.description||`Save for ${f.title}`,target:Number(f.target)||0,saved:Number(f.saved)||0,deadline:f.deadline||new Date(Date.now()+365*86400000).toISOString().split("T")[0],createdAt:new Date().toISOString(),history:Number(f.saved)>0?[{id:1,amount:Number(f.saved),note:"Initial balance",date:new Date().toISOString()}]:[]};setNid(n=>n+1);save([...goals,ng]);setShowAdd(false); };
  const editGoal=(f)=>{ save(goals.map(g=>g.id===selId?{...g,title:f.title,description:f.description,category:f.category,target:Number(f.target),deadline:f.deadline}:g));setShowEdit(false); };
  const logAmt=(amount,note)=>{ save(goals.map(g=>g.id===selId?{...g,saved:g.saved+amount,history:[...g.history,{id:Date.now(),amount,note:note||"Deposit",date:new Date().toISOString()}]}:g));setShowLog(false); };
  const delGoal=()=>{ if(window.confirm("Delete this goal?")){ save(goals.filter(g=>g.id!==selId));setView("dash"); } };
  const saveProfile=(upd)=>{ const u=LS.get("st_users")||{};const updated={...user,...upd};u[user.phone]=updated;LS.set("st_users",u);setShowProfile(false);window.location.reload(); };

  const tt=goals.reduce((a,g)=>a+Number(g.target),0);
  const ts=goals.reduce((a,g)=>a+Number(g.saved),0);
  const op=tt>0?(ts/tt)*100:0;

  return (
    <div style={{ maxWidth:480,margin:"0 auto",minHeight:"100vh",background:"#F7F9FC",position:"relative",fontFamily:"'DM Sans',sans-serif" }}>
      {view==="dash"&&(
        <div style={{ paddingBottom:90 }}>
          {/* Header */}
          <div style={{ background:"#fff",padding:"12px 16px",display:"flex",justifyContent:"space-between",alignItems:"center",borderBottom:"1px solid #F0F4F8",position:"sticky",top:0,zIndex:10,boxShadow:"0 2px 12px rgba(0,0,0,0.04)" }}>
            {/* LEFT: Full Logo */}
            <img src={LOGO_SRC} alt="Savings Tracker" style={{ height:38,objectFit:"contain",maxWidth:160 }} />
            {/* RIGHT: Profile pic + Settings (opens settings with profile) */}
            <div onClick={()=>setShowSettings(true)} style={{ display:"flex",alignItems:"center",gap:8,cursor:"pointer",background:"#F1F5F9",borderRadius:14,padding:"5px 10px 5px 5px" }}>
              <div style={{ width:32,height:32,borderRadius:"50%",background:"linear-gradient(135deg,#3B82F6,#2563EB)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,color:"#fff",fontWeight:900,overflow:"hidden",flexShrink:0 }}>
                {user?.photo?<img src={user.photo} alt="" style={{ width:"100%",height:"100%",objectFit:"cover" }}/>:(user?.name?.[0]?.toUpperCase()||"U")}
              </div>
              <span style={{ fontSize:13,fontWeight:700,color:"#1A202C",maxWidth:80,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap" }}>{user?.name?.split(" ")[0]}</span>
              <span style={{ fontSize:18 }}>⚙️</span>
            </div>
          </div>

          {/* Banner */}
          <div style={{ background:"linear-gradient(135deg,#0F172A 0%,#1E3A8A 55%,#1D4ED8 100%)",margin:"16px 16px 0",borderRadius:22,padding:"20px",color:"#fff",boxShadow:"0 8px 32px rgba(6,78,59,0.35)" }}>
            <div style={{ fontSize:11,fontWeight:700,opacity:.7,letterSpacing:1,textTransform:"uppercase" }}>Total Savings</div>
            <div style={{ fontSize:30,fontWeight:900,margin:"6px 0 2px" }}>{formatINR(ts)}</div>
            <div style={{ fontSize:12,opacity:.6,marginBottom:14 }}>of {formatINR(tt)} total goal</div>
            <div style={{ background:"rgba(255,255,255,0.15)",borderRadius:99,height:7,overflow:"hidden" }}>
              <div style={{ height:"100%",borderRadius:99,background:"#fff",width:`${op}%`,transition:"width .8s ease" }}/>
            </div>
            <div style={{ display:"flex",justifyContent:"space-between",marginTop:8 }}>
              <span style={{ fontSize:12,opacity:.7 }}>{Math.round(op)}% achieved</span>
              <span style={{ fontSize:12,opacity:.7 }}>{goals.length} goals</span>
            </div>
          </div>

          {/* Goals */}
          <div style={{ padding:"16px 16px 0" }}>
            <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12 }}>
              <span style={{ fontSize:16,fontWeight:900,color:"#1A202C" }}>My Goals ({goals.length})</span>
              <button onClick={()=>setShowReorder(true)} style={{ border:"1.5px solid #DBEAFE",background:"#EFF6FF",borderRadius:10,padding:"6px 12px",cursor:"pointer",color:"#2563EB",fontSize:12,fontWeight:700 }}>⇅ Reorder</button>
            </div>
            {goals.length===0?(
              <div style={{ background:"#fff",borderRadius:24,padding:"40px 24px",textAlign:"center",boxShadow:"0 2px 16px rgba(0,0,0,0.07)",border:"1.5px dashed #BFDBFE",marginTop:8 }}>
                <div style={{ fontSize:60,marginBottom:12 }}>🎯</div>
                <h3 style={{ fontSize:19,fontWeight:900,color:"#0F172A",margin:"0 0 8px",fontFamily:"'DM Sans',sans-serif" }}>No Goals Yet!</h3>
                <p style={{ fontSize:14,color:"#64748B",margin:"0 0 24px",lineHeight:1.6 }}>Start your savings journey! Add your first goal — a dream car, vacation, phone, or anything you want to save for.</p>
                <button onClick={()=>setShowAdd(true)} style={{ background:"linear-gradient(135deg,#3B82F6,#2563EB)",color:"#fff",border:"none",borderRadius:14,padding:"14px 28px",fontSize:15,fontWeight:800,cursor:"pointer",boxShadow:"0 4px 16px rgba(59,130,246,0.4)",fontFamily:"'DM Sans',sans-serif" }}>＋ Add My First Goal</button>
              </div>
            ):(
              <div style={{ display:"flex",flexDirection:"column",gap:12 }}>
                {goals.map((g,i)=>(
                  <div key={g.id} style={{ animation:`fadeIn .4s ease ${i*.07}s both` }}>
                    <GoalCard goal={g} onClick={()=>{ setSelId(g.id);setView("detail"); }}/>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* FAB */}
          <button onClick={()=>setShowAdd(true)} style={{ position:"fixed",bottom:28,right:"max(20px,calc(50% - 220px))",width:58,height:58,borderRadius:"50%",border:"none",background:"linear-gradient(135deg,#3B82F6,#2563EB)",color:"#fff",fontSize:28,cursor:"pointer",boxShadow:"0 8px 28px rgba(16,185,129,0.55)",display:"flex",alignItems:"center",justifyContent:"center",transition:"transform .2s",zIndex:50 }}
            onMouseEnter={e=>{e.currentTarget.style.transform="scale(1.12)";}} onMouseLeave={e=>{e.currentTarget.style.transform="";}}>+</button>
        </div>
      )}

      {view==="detail"&&sel&&<GoalDetail goal={sel} onBack={()=>setView("dash")} onEdit={()=>setShowEdit(true)} onLog={()=>setShowLog(true)} onDelete={delGoal}/>}

      <Modal show={showAdd} onClose={()=>setShowAdd(false)} title="New Savings Goal"><GoalForm onSave={addGoal} onCancel={()=>setShowAdd(false)}/></Modal>
      <Modal show={showEdit&&!!sel} onClose={()=>setShowEdit(false)} title="Edit Goal">{sel&&<GoalForm initial={{ title:sel.title,description:sel.description,category:sel.category,target:sel.target,saved:sel.saved,deadline:sel.deadline }} onSave={editGoal} onCancel={()=>setShowEdit(false)}/>}</Modal>
      <LogModal show={showLog} goal={sel} onClose={()=>setShowLog(false)} onSave={logAmt}/>
      <SettingsMenu show={showSettings} onClose={()=>setShowSettings(false)} user={user} onLogout={onLogout} onEditProfile={()=>setShowProfile(true)}/>
      {showProfile&&<EditProfile user={user} onSave={saveProfile} onClose={()=>setShowProfile(false)}/>}
      <Modal show={showReorder} onClose={()=>setShowReorder(false)} title="Reorder Goals"><Reorder goals={goals} onChange={save} onDone={()=>setShowReorder(false)}/></Modal>
    </div>
  );
};

/* ════════════════════════════════════════════════════════════════
   ROOT
═══════════════════════════════════════════════════════════════ */
export default function App() {
  // Set favicon + page title dynamically
  useEffect(()=>{
    document.title = "Savings Tracker";
    let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/jpeg"; link.rel = "shortcut icon"; link.href = ICON_SRC;
    document.getElementsByTagName("head")[0].appendChild(link);
  },[]);
  const [page,setPage]=useState("landing"); // landing | auth | app
  const [authMode,setAuthMode]=useState("login");
  const [user,setUser]=useState(null);

  useEffect(()=>{
    const s=LS.get("st_session");
    if(s){ const u=(LS.get("st_users")||{})[s];if(u){ setUser(u);setPage("app"); } }
  },[]);

  const goSignup=()=>{ setAuthMode("signup");setPage("auth"); };
  const goLogin=()=>{ setAuthMode("login");setPage("auth"); };
  const handleLogin=(u)=>{ setUser(u);setPage("app"); };
  const handleLogout=()=>{ LS.del("st_session");setUser(null);setPage("landing"); };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;0,9..40,800;0,9..40,900;1,9..40,400&display=swap');
        *{box-sizing:border-box;-webkit-tap-highlight-color:transparent;}
        body{margin:0;background:#fff;font-family:'DM Sans',sans-serif;-webkit-font-smoothing:antialiased;overscroll-behavior:none;}
        input,button,textarea,select{font-family:'DM Sans',sans-serif;}
        input:focus{outline:none;}
        button:active{transform:scale(0.97);}
        ::-webkit-scrollbar{width:4px;} ::-webkit-scrollbar-thumb{background:#E2E8F0;border-radius:99px;}
        @keyframes slideUp{from{transform:translateY(100%);opacity:0}to{transform:translateY(0);opacity:1}}
        @keyframes fadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}
        @keyframes fadeInScale{from{opacity:0;transform:scale(0.95)}to{opacity:1;transform:scale(1)}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}
        @keyframes shimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}
        .slide-up{animation:slideUp .35s cubic-bezier(.16,1,.3,1);}
        .fade-in{animation:fadeIn .4s ease both;}
        .pulse{animation:pulse 1.5s ease infinite;}
      `}</style>
      {page==="landing"&&<LandingPage onSignup={goSignup} onLogin={goLogin}/>}
      {page==="auth"&&<AuthScreen onLogin={handleLogin} onBack={()=>setPage("landing")} initialMode={authMode}/>}
      {page==="app"&&user&&<Dashboard user={user} onLogout={handleLogout}/>}
    </>
  );
}
